import React, {useState} from 'react';
import Header from "../../../layouts/Header";
import {getOrganizationInfo} from "../api/ProfileAPIs";
import {showError} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";
import {BsInstagram, BsMap, BsPhoneVibrate, BsTelegram, BsWhatsapp} from "react-icons/bs";

import { MapContainer, Marker, TileLayer, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import MapMarker from "../../../assets/images/mapMarker.png";


let DefaultIcon = L.icon({
    iconUrl: MapMarker,
    iconSize: [16,16],
});

L.Marker.prototype.options.icon = DefaultIcon;

const Contact = () => {

    const [organization , setOrganization] = React.useState([]);
    const [loading, setLoading] = useState(true);


    React.useEffect(() => {

        const fetchOrganization = async () => {
            try {
                const data = await getOrganizationInfo();
                setOrganization(data.data[0]);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchOrganization();

    }, []);


    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title=' تماس با ما ' hasBack={true} />

            <main className="container ltr mt-5 pt-4 contact">
                <div className="row px-3 ">
                    <div className="col-12 mb-4">
                        <div className="card text-center bg-secondary py-3 text-small-1 text-white fw-bold "

                        >
                            <div className='text-center mb-2 text-big-5'>
                                <BsMap className='text-big-5'/>
                            </div>
                            <div>
                                {
                                    organization.address
                                }
                            </div>

                        </div>
                    </div>
                    <div className="col-12 mb-4">
                        <a className="card text-center bg-info py-3 d-block text-small-1 text-white fw-bold "
                           href={`tel:${organization.phone}`}
                        >
                            <div className='text-center mb-2 text-big-5'>
                                <BsPhoneVibrate className='text-big-5'/>
                            </div>
                            <div>
                                {
                                    organization.phone
                                }
                            </div>

                        </a>
                    </div>
                    <div className="col-4">
                        <div className="card text-center bg-success py-3 text-small-1 text-white "
                             onClick={() => {
                                 window.open(`https://wa.me/${organization.whatsapp}?external=true`)
                             }}
                        >
                            <div className='text-center mb-2 text-big-5'>
                                <BsWhatsapp className='text-big-5'/>
                            </div>
                            <div className='text-small-2'>
                                {
                                    organization.whatsapp
                                }
                            </div>

                        </div>
                    </div>
                    <div className="col-4">
                        <div className="card text-center bg-primary py-3 text-small-1 text-white "
                             onClick={() => {
                                 window.open(`https://t.me/${organization.telegram}?external=true`)
                             }}
                        >
                            <div className='text-center mb-2 text-big-5'>
                                <BsTelegram className='text-big-5'/>
                            </div>
                            <div className='text-small-2 ltr'>

                                {
                                    organization.telegram
                                }
                            </div>

                        </div>
                    </div>
                    <div className="col-4">
                        <div className="card text-center bg-danger py-3 text-small-1 text-white "
                             onClick={() => {
                                 window.open(`https://instagram.com/${organization.instagram_user}?external=true`)
                             }}
                        >
                            <div className='text-center mb-2 text-big-5'>
                                <BsInstagram className='text-big-5'/>
                            </div>
                            <div className='text-small-2 ltr'>

                                {
                                    organization.instagram_user
                                }
                            </div>

                        </div>
                    </div>

                    <div className="col-12 mt-4  ">



                        <MapContainer
                            center={[organization.lat,organization.lng]}
                            zoom={13}
                            scrollWheelZoom={true}

                        >
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker
                                position={[organization.lat, organization.lng]}
                            >
                                <Popup>
                                    A pretty CSS3 popup. <br/> Easily customizable.
                                </Popup>
                            </Marker>
                        </MapContainer>


                    </div>
                </div>

            </main>

        </React.Fragment>
    );
};

export default Contact;